export const headCellsConsegne = [
    {id: "numero", label: "Numero", width: "20%"},
    {id: "indirizzoDiConsegna", label: "Indirizzo di consegna", width: "25%"},
    {id: "dataOrdine", label: "Data ordine", width: "20%"},
    {id: "stato", label: "Stato", width: "20%"},
    {id: "vediDettagli", label: "", width: "15%"}
]

export const sortingCriteriaConsegna = [
    {text: "Numero", value: "numero"},
    {text: "Data", value: "data"},
    {text: "Stato", value: "stato"}
];


export const headCellsConsegnati = [
    {id: "imei", label: "Codice IMEI", width: "25%"},
    {id: "indirizzoDiConsegna", label: "Indirizzo di consegna", width: "35%"},
    {id: "tipoAssistenza", label: "Tipo assistenza", width: "40%"},
]

export const sortingCriteriaConsegnati = [
    {text: "Codice IMEI", value: "imei"},
    {text: "Tipo Assistenza", value: "tipoAssistenza"}
];